import React from 'react';
import { connect } from 'redux-bundler-react';
import { SidebarButton } from '../../application-controls/index';
import classnames from 'classnames';
import DatasetInfo from './help-info-modal';

class HelpButton extends React.Component {
  constructor(props){
    super(props);
    this.openMetadata = this.openMetadata.bind(this);
  }
  openMetadata(){
    const { doOpenModalWindow } = this.props;
    
    doOpenModalWindow({
      children: [DatasetInfo],
      openedBy: 'helpButton'
    })
  }

  render() {
    
    return (
      <SidebarButton
        iconClass="mdi mdi-help-circle-outline"
        label="Help"
        title="Help"
        onClick={ this.openMetadata }
      />
    );
  }
}

export default connect(
  'doOpenModalWindow',
  HelpButton
);